import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { generateId, shortHandDate } from '../../utility/functions';
import Table from '../../table/Table';
import ManagementRow from '../../table/ManagementRow';
import { userRoles } from '../../RoleProtected';
import Button from '../../forms/Button';
import { voidCode } from '../codes/Codes';
import GetState from '../../GetState';

const ClaimedDeals = ({ children, ...props }) => {
    const { guid } = useParams();

    const [data, refreshData] = GetState(QuestRoute.user.claimedDeals(guid))

    const tableConfig = {
        data,
        //isReport: true,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
                options: true
            }, {
                label: 'Claimed',
                propKey: 'claimed',
                type: 'date'
            }, {
                label: 'Expires',
                propKey: 'expires',
                type: 'date'
            }, {
                label: 'Last Used',
                propKey: 'lastUsed',
                type: 'date'
            }, {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Voided',
                propKey: 'isVoided',
                options: true
            },
        ],
        // quickSort: [],
        renderFormat: (e) => (
            <ManagementRow
                key={generateId()}
                controls={[
                    <Button
                        roles={userRoles.admin}
                        key={generateId()}
                        onClick={() => voidCode(e.code).then(() => refreshData())}
                        label='Void Code'
                    />,
                ]}
            >
                <td>{e.name}</td>
                <td>{shortHandDate(e.claimed)}</td>
                <td>{shortHandDate(e.expires)}</td>
                <td>{shortHandDate(e.lastUsed)}</td>
                <td>{e.code}</td>
                <td>{e.isVoided ? 'Yes' : 'No'}</td>
            </ManagementRow>
        )
    }

    return <Table config={tableConfig} />
}

export default ClaimedDeals;
